export default __webpack_public_path__ + "static/media/blob.862ea647.png";